import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import RegisterFrom from './RegisterFrom';
import imgg from '../../../assets/images/login/1.jpg';

const RegisterBgImg2 = () => {
  return (
    <section>
      <Container fluid={true} className='p-0'>
        <Row className='m-0'>
          <Col xl='7' className='p-0 bg-size b-center' style={{ backgroundImage: `url(${imgg})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center', display: 'block' }}></Col>
          <Col xl='5' className='p-0'>
            <div className='login-card'>
              <RegisterFrom headclass={'text-start'} />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default RegisterBgImg2;
